import { RestApi } from '../restApi';

import type { FeatureFlagsRESTResponse, SettingsRESTResponse } from './types';
import type { AxiosError, AxiosResponse } from 'axios';

export class SettingsApi extends RestApi {
  static async getFeatureFlags(): Promise<FeatureFlagsRESTResponse> {
    try {
      const response: AxiosResponse<FeatureFlagsRESTResponse> = await this.woofApi.get(
        '/v1/feature_flags'
      );

      return { ...response.data };
    } catch (error) {
      this.handleError(error as AxiosError);

      throw error;
    }
  }

  static async getSettings(): Promise<SettingsRESTResponse | null> {
    try {
      const response: AxiosResponse<SettingsRESTResponse> = await this.woofApi.get('/v1/settings');

      return { ...response.data };
    } catch (error) {
      return this.handleError(error as AxiosError);
    }
  }
}
